export function LoadingState({ label = "Reading the latest report snapshot." }: { label?: string }) {
  return <main id="main-content" className="site-shell page-space"><div className="empty-state loading-state"><p className="eyebrow">LOADING PUBLIC DATA</p><p className="empty-state-title">{label}</p></div></main>;
}
